import {CanvasSkeleton} from "@app/components/WidgetStudio/Canvas/skeletons/DesktopSkeleton/CanvasSkeleton"
import {Skeleton} from '@shortsworks/ui';
import {Search, ShoppingCart} from "lucide-react"

export const MobileSkeletonHeader = () => {
  return (
    <div className="flex w-full gap-4 p-4">
        <CanvasSkeleton className="h-8 w-full rounded-2xl flex items-center justify-end px-2">
            <Search className="h-4 w-4 text-foreground" />
        </CanvasSkeleton>
        <div className="w-1/2 flex gap-4">
            <CanvasSkeleton className="h-8 w-1/2 rounded-xl flex items-center justify-end px-2">
                <ShoppingCart className=" h-4 w-4" />
            </CanvasSkeleton>
            <CanvasSkeleton className="h-8 w-1/2 rounded-lg" />
        </div>
    </div>

  )
}
